import { ApiService } from '../../services/api_service';
import * as config from '../../wips.config.js';
import { Datenverwaltung } from './datenverwaltung/Datenverwaltung';
import { DevelopmentPreview } from './DevelopmentPreview';
import { FaktorenFeedback } from '../../main/FaktorenFeedback';
import { getTabRechte } from '../../helpers/getTabRechte';
import { IDs } from '../../helpers/IDs';
import { i18n } from '../../i18n/i18n';
import { KennzahlenDatenbank } from './kennzahlen/KennzahlenDatenbank';
import { Kommunikation } from './kommunikation/Kommunikation';
import { Kontakt } from './Kontakt';
import { lazyInject } from '../../services/inversify';
import { PvTool } from './pv_tool/PvTool';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingAdminIDs';
import { Startseite } from './start/Startseite';
import { StatistikTabs } from './statistik/StatistikTabs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../css/tabs.css';
import { ToolPruefung } from './ToolPruefung';
import { UnternehmenTabs } from './unternehmen/UnternehmenTabs';
import { Versionshistorie } from './Versionshistorie';
import { WRechte } from '../../core/rechte/WRechte';

interface AdminMainTabsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface AdminMainTabsState extends React.ClassAttributes<any> {
    rechte: any;
    tabIndex: number;
    tabIndexStart: number;
}

export class AdminMainTabs extends React.Component<AdminMainTabsProps, AdminMainTabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            rechte: null,
            tabIndex: RoutingIDs.MENUE_DATENVERWALTUNG,
            tabIndexStart: null
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private devFeatures: boolean = config.devFeatures || false;
    private disabled: string[] = [];
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_START },
        { path: RoutingIDs.ROUTE_RECHTEVERWALTUNG },
        { path: RoutingIDs.ROUTE_DATENVERWALTUNG },
        { path: RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK },
        { path: RoutingIDs.ROUTE_PV_TOOL },
        { path: RoutingIDs.ROUTE_KOMMUNIKATION },
        { path: RoutingIDs.ROUTE_STATISTIK },
        { path: RoutingIDs.ROUTE_VERSIONSHISTORIE },
        { path: RoutingIDs.ROUTE_FEEDBACK_FAKTOREN },
        { path: RoutingIDs.ROUTE_TOOL_PRUEFUNG },
        { path: RoutingIDs.ROUTE_KONTAKT },
        { path: RoutingIDs.ROUTE_PREVIEW_TEST }
    ];
    private tabs: string[] = [ // Reitereihenfolge beachten
        'startseite', 'rechteverwaltung', 'datenverwaltung', 'kennzahlen_datenbank', 'unternehmensdatenbank', 'pv_tool', 'kommunikation',
        'statistik', 'versionshistorie', 'feedback_faktoren', 'tool_pruefung', 'kontakt',
        'preview_test'
    ];

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const selectedMenu: number = ((this.props.routing || {}).path || {}).selectedMenu;

        if (typeof selectedMenu === 'number') {
            const tabIndex: number = this.state.rechte[this.tabs[selectedMenu] || null] ? selectedMenu : this.state.tabIndexStart;

            if (this.state.tabIndexStart === null) {
                return;
            }
            this.setState({ tabIndex });
        }
    }

    init(): void {
        if (!this.devFeatures) {
            this.disabled = [...this.disabled, 'feedback_faktoren', 'kontakt'];
        }
        const prefix: string = 'admin.tab';
        const data: any = getTabRechte({ disabled: this.disabled, prefix, tabs: this.tabs }) || {};
        const rechte: any = data.rechte || {};
        const tabIndex: number = rechte[this.tabs[this.state.tabIndex] || null] ? this.state.tabIndex : data.tabIndex;

        if (data.tabIndex === null) {
            return;
        }
        this.setState(
            { rechte, tabIndexStart: data.tabIndex },
            () => data.tabIndex !== tabIndex ? this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]) : null
        );
    }

    render(): JSX.Element {
        if (!this.state.rechte) {
            return null;
        }
        const menue: number = this.state.tabIndex;
        const rechte: any = this.state.rechte;
        const styleTabPanel: React.CSSProperties = { flexDirection: 'column', display: 'flex', minHeight: 0, overflowY: 'auto' };
        const showTabTest = true;

        return (
            <Tabs
                className='tabs-admin-main'
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                selectedIndex={this.state.tabIndex || 0}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList style={{ minHeight: 20 }}>
                    <Tab disabled={!rechte.startseite}>{i18n('START', 'tab')}</Tab>
                    <Tab disabled={!rechte.rechteverwaltung}>{i18n('Rechteverwaltung', 'tab')}</Tab>
                    <Tab disabled={!rechte.datenverwaltung}>{i18n('Datenverwaltung', 'tab')}</Tab>
                    <Tab disabled={!rechte.kennzahlen_datenbank}>{i18n('Kennzahlen-Datenbank', 'tab')}</Tab>
                    <Tab disabled={!rechte.unternehmensdatenbank}>{i18n('Unternehmensdatenbank', 'tab')}</Tab>
                    <Tab disabled={!rechte.pv_tool}>{i18n('PV-Tool', 'tab')}</Tab>
                    <Tab disabled={!rechte.kommunikation}>{i18n('Kommunikation', 'tab')}</Tab>
                    <Tab disabled={!rechte.statistik}>{i18n('Statistik', 'tab')}</Tab>
                    <Tab disabled={!rechte.versionshistorie}>{i18n('Versionshistorie', 'tab')}</Tab>
                    <Tab disabled={!rechte.feedback_faktoren}>{i18n('Feedback / Faktoren', 'tab')}</Tab>
                    <Tab disabled={!rechte.tool_pruefung}>{i18n('Tool-Prüfung', 'tab')}</Tab>
                    <Tab disabled={!rechte.kontakt}>{i18n('Kontakt', 'tab')}</Tab>
                    <Tab disabled={!showTabTest}>{i18n('Preview / Test', 'tab')}</Tab>
                </TabList>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 0 ? 1 : 0 }}>
                    {rechte.startseite &&
                        <Startseite
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 1 ? 1 : 0 }}>
                    {rechte.rechteverwaltung &&
                        <WRechte
                            modul={IDs.MOD_ETOOL_ADMIN}
                            costumClass='Custom-ETA'
                            formLayout='flowV2'
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 2 ? 1 : 0 }}>
                    {rechte.datenverwaltung &&
                        <Datenverwaltung
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortSelected={this.props.standortSelected}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 3 ? 1 : 0 }}>
                    {rechte.kennzahlen_datenbank &&
                        <KennzahlenDatenbank
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 4 ? 1 : 0 }}>
                    {rechte.unternehmensdatenbank &&
                        <UnternehmenTabs
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortSelected={this.props.standortSelected}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 5 ? 1 : 0 }}>
                    {rechte.pv_tool &&
                        <PvTool
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 6 ? 1 : 0 }}>
                    {rechte.kommunikation &&
                        <Kommunikation
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 7 ? 1 : 0 }}>
                    {rechte.statistik &&
                        <StatistikTabs
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                        />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 8 ? 1 : 0 }}>
                    {rechte.versionshistorie &&
                        <Versionshistorie />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 9 ? 1 : 0 }}>
                    {rechte.feedback_faktoren &&
                        <FaktorenFeedback data={this.props.data} isAdmin />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 10 ? 1 : 0 }}>
                    {rechte.tool_pruefung &&
                        <ToolPruefung />
                    }
                </TabPanel>
                <TabPanel style={{ ...styleTabPanel, flex: menue === 11 ? 1 : 0 }}>
                    {rechte.kontakt &&
                        <Kontakt />
                    }
                </TabPanel>
                <TabPanel>
                    {showTabTest &&
                        <DevelopmentPreview data={this.props.data} />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any): void {
        if (this.state.tabIndex !== tabIndex) {
            this.setState({ tabIndex }, () => {
                this.props.onRoutingChange(tabRouting);
            });
        }
    }
}
